// extracted by mini-css-extract-plugin
export default {"container":"WaterMainInfo_container__rDzlV"};